export default "<app-prescription-list></app-prescription-list>\r\n";